import React, { Component } from 'react';

import { trans } from '../../../../../localization/index';
import PageTable, {
  PageTableCell,
  PageTableHeader,
  PageTableRow,
} from '../../../../../components/Table/PageTable';
import { EnumPagingMode } from '../../../../../constants/enum';
import { formatDateTimeView } from '../../../../../utils/utils';

class TransactionRestaurantTable extends Component {
  static renderHeader() {
    const columns = [
      {
        id: 'number',
        label: trans('mod_header_transaction_stt'),
        width: '5%',
        textAlign: 'center',
      },
      {
        id: 'restaurant',
        label: trans('mod_header_transaction_total'),
        width: '30%',
        textAlign: 'right',
      },
      {
        id: 'address',
        label: trans('mod_header_transaction_order_code'),
        width: '30%',
        textAlign: 'center',
      },
      {
        id: 'status',
        label: trans('mod_header_transaction_create_date'),
        width: '35%',
        textAlign: 'center',
      },
    ];

    return <PageTableHeader columns={columns} />;
  }

  static renderEmpty() {
    return (
      <PageTableRow>
        <PageTableCell colSpan={5}>
          {trans('mod_not_find_restaurant')}
        </PageTableCell>
      </PageTableRow>
    );
  }

  renderRow = (row, index) => {
    const {
      order_code: orderCode,
      create_time: createTime,
      amount,
      transaction_id: transactionId,
    } = row;

    return (
      <PageTableRow key={transactionId}>
        <PageTableCell textAlign="center">{index}</PageTableCell>
        <PageTableCell textAlign="right">
          <strong className="text-green">+{amount}</strong>
        </PageTableCell>
        <PageTableCell textAlign="center">
          <span>{orderCode}</span>
        </PageTableCell>
        <PageTableCell textAlign="center">
          {formatDateTimeView(createTime)}
        </PageTableCell>
      </PageTableRow>
    );
  };

  render() {
    const { table, changeActivePage, changePageSize } = this.props;
    return (
      <PageTable
        paginationMode={EnumPagingMode.SELF_PAGING.id}
        renderHeader={TransactionRestaurantTable.renderHeader}
        renderRow={this.renderRow}
        table={table}
        renderEmpty={TransactionRestaurantTable.renderEmpty}
        changeActivePage={changeActivePage}
        changePageSize={changePageSize}
      />
    );
  }
}
export default TransactionRestaurantTable;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/ReportRestaurant/TransactionRestaurant/components/TransactionRestaurantTable.jsx